export const scrollToTop = () => {
	window.scrollTo({
		left: 0,
		top: 0,
		behavior: "smooth",
	});
};
